"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ThemeProvider", {
  enumerable: true,
  get: function () {
    return _styledComponents.ThemeProvider;
  }
});
exports.default = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _IconLibrary = require("../../packages/IconLibrary");
var _index = require("../AccordionDrawer/index.styled");
var _DynamicHeading = require("../DynamicHeading");
var _LexusTypography = require("../LexusTypography");
var _index2 = _interopRequireDefault(require("../MediaComponent/index.styled"));
var _Typography = require("../Typography");
var _breakpoints = _interopRequireDefault(require("../breakpoints"));
const tabsUnifiedLineStyles = `
  overflow: auto;
  margin-bottom: -20px;
  padding-bottom: 45px;
  .react-tabs {
    overflow: initial;
    margin-bottom: 20px;
  }
  ul {
    margin: auto;
    padding: 0 20px;
    margin: 0;
    list-style: none;
    display: flex;
    overflow: initial;
    &:before, &:after {
      content: '';
      margin: auto;
    }
  }
  li {
    margin: 0;
    border-bottom: 1px solid #d9d9d9;
    padding: 12px 30px;
    position: relative;
    &:last-child {
      &:after {
        content: "";
        display: block;
        position: absolute;
        right: -20px;
        width: 20px;
        height: 1px;
        left: initial;
        background: transparent;
      }
    }
    &:not(.react-tabs__tab--selected) span {
      font-family: 'nobel-regular';
    }
    &.react-tabs__tab--selected span {
      &:after {
        content: '';
        width: 100%;
        height: 3px;
        background: var(--app-primary-text-color, #000);
        display: block;
        position: absolute;
        bottom: -1px;
        left: 0;
      }
    }
  }
`;
const TabList = _styledComponents.default.div`
  margin-bottom: 25px;
  .react-tabs {
    overflow: hidden;
  }
  ul {
    display: flex;
    margin: auto;
    padding: 0;
    margin: 0;
    list-style: none;
    overflow: auto;
    margin-bottom: -20px;
    padding-bottom: 20px;
    &:before,
    &:after {
      content: "";
      margin: auto;
    }
  }
  li {
    cursor: pointer;
    margin: 0 17px;
    padding-top: 10px;
    white-space: nowrap;
    position: relative;
    &.react-tabs__tab--selected:after {
      content: "";
      width: 100%;
      height: 1px;
      background: var(--app-primary-text-color, #000);
      position: absolute;
      bottom: 0;
      left: 0;
    }
    &:not(.react-tabs__tab--selected) span {
      font-family: "nobel-regular";
    }
    &:hover span {
      font-family: "nobel-bold";
    }
  }

  ${function (_ref) {
  let {
    $tabsUnifiedLine
  } = _ref;
  return $tabsUnifiedLine && `
    ${(0, _breakpoints.default)("mobile")} {
      ${tabsUnifiedLineStyles}
      margin: 0 0 25px;
      padding-bottom: unset;
      .react-tabs {
        margin-bottom: unset;
      }
      ul {
        padding: 0 20px 10px;
      }
    }
  `;
}}
`;
const Stage = _styledComponents.default.div`
  flex-grow: 0;
  position: relative;
  ${function (_ref2) {
  let {
    $overlay
  } = _ref2;
  return !$overlay && `margin-bottom: 25px;`;
}}
  background: var(--app-background-color, #FFF);
  & .v360-fullscreen {
    z-index: 0;
  }
`;
const SvgContainer = _styledComponents.default.div`
  width: var(--visualizer-inactive-swatch-size, 42px);
  height: var(--visualizer-inactive-swatch-size, 42px);
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  ${function (_ref3) {
  let {
    $noBorder
  } = _ref3;
  return !$noBorder && `
    border: var(--visualizer-inactive-swatch-border-width, 2px) solid var(--visualizer-inactive-swatch-border-color, transparent);
  `;
}}

  svg {
    width: 25px;
  }
`;
var _default = exports.default = {
  Visualizer: _styledComponents.default.div`
    display: block;
    position: relative;
    box-sizing: border-box;
    margin: auto;
    max-width: 1204px;
    padding: 0;
    color: ${function (_ref4) {
    let {
      $textColor
    } = _ref4;
    return $textColor || `var(--app-primary-text-color, #000)`;
  }};
    ${(0, _breakpoints.default)("desktop", "up")} {
      padding: 0 40px;
    }
    background: var(--app-background-color, #fff);
  `,
  Heading: (0, _styledComponents.default)(_DynamicHeading.DynamicHeading).attrs({
    defaultLevel: 3
  })`
    ${(0, _LexusTypography.nobel)({
    sizing: "heading24",
    weight: "book"
  })}
    text-align: center;
    margin-top: 0;
    margin-bottom: 30px;
    ${(0, _breakpoints.default)("tablet", "up")} {
      margin-bottom: 40px;
    }
  `,
  TabStyle: (0, _Typography.StyledType)("span", {
    size: "linkCopy1",
    family: "nobel-bold"
  })`
  `,
  TabList,
  TrimList: (0, _styledComponents.default)(TabList)`
    ${(0, _breakpoints.default)("mobile")} {
      ${tabsUnifiedLineStyles}
    }
  `,
  SwatchList: _styledComponents.default.div`
    margin-bottom: 15px;
    min-height: 46px;
    ${function (_ref5) {
    let {
      $hasModifiers
    } = _ref5;
    return $hasModifiers && `
      display: flex;
      justify-content: center;
      .react-tabs {
        padding: 0 10px;
      }
      .modifierTabs {
        border-right: 1px solid #818181;
        img {
          width: 84px;
          border: none;
        }
        li {
          opacity: 0.54;
          &.react-tabs__tab--selected {
            opacity: 1;
            img {
              width: 84px;
              border: none;
            }
          }
        }
      }
    `;
  }}
    .swiper-horizontal {
      width: var(--visualizer-swatch-swiper-width-mobile, 240px);
      ${(0, _breakpoints.default)("tablet", "up")} {
        width: var(--visualizer-swatch-swiper-width-tablet-up, 480px);
      }
    }
    ul {
      margin: auto;
      padding: 0;
      margin: 0;
      list-style: none;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    li {
      cursor: pointer;
      margin: 0 var(--visualizer-swatch-left-right-margin, 1px);
      display: block !important;

      &.react-tabs__tab--selected img {
        width: 42px;
        border: 2px solid var(--visualizer-active-swatch-border-color, #b2a277);
      }
      &.react-tabs__tab--selected ${SvgContainer} {
        width: 42px;
        height: 42px;
        border: 2px solid var(--visualizer-active-swatch-border-color, #b2a277);
      }
    }
    img {
      border: var(--visualizer-inactive-swatch-border-width, 2px) solid
        var(--visualizer-inactive-swatch-border-color, transparent);
      display: block;
      width: var(--visualizer-inactive-swatch-size, 42px);
    }
  `,
  SwatchContainer: _styledComponents.default.div`
    position: relative;
    display: flex;
    .swiper-wrapper {
      justify-content: center;
    }
    .swiper-button-prev {
      left: -30px;
      ${(0, _breakpoints.default)("tablet", "down")} {
        z-index: 4;
      }
    }
    .swiper-button-next {
      right: -30px;
      ${(0, _breakpoints.default)("tablet", "down")} {
        z-index: 4;
      }
    }
  `,
  SvgContainer,
  Stage,
  Background: _styledComponents.default.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("${function (_ref6) {
    let {
      image
    } = _ref6;
    return image;
  }}");
    transition: background-position 0.3s;
    background-position: center;
    background-size: cover;
    ${function (_ref7) {
    let {
      position
    } = _ref7;
    if (position === "high") return "background-position: top";
    if (position === "low") return "background-position: bottom";
  }}
  `,
  JellyCarousel: _styledComponents.default.div`
    position: relative;
    width: 100%;
    ${function (_ref8) {
    let {
      $overlay,
      $is360Variant
    } = _ref8;
    return !$overlay ? $is360Variant ? `aspect-ratio: 1.25;` : `aspect-ratio: 2.295;` : ``;
  }}
    ${(0, _breakpoints.default)("tablet", "up")} {
      ${function (_ref9) {
    let {
      $overlay,
      $is360Variant
    } = _ref9;
    return !$overlay && $is360Variant && `aspect-ratio: 2.298;`;
  }}
    }
    margin: auto;
    ${function (_ref10) {
    let {
      $is360Variant
    } = _ref10;
    return $is360Variant && `
      display: flex;
      justify-content: center;
      align-items: center;

      .v360-viewport {
        background-color: transparent;
      }
      .v360-spinner-grow {
        display: none;
      }

      .v360-viewport,
      .v360-image-container {
        display: block;
      }
    `;
  }}
    ${function (_ref11) {
    let {
      $overlay,
      $is360Variant
    } = _ref11;
    return $overlay && $is360Variant && `
      .v360-viewport {
        width: 100vw;
        max-height: calc(100vh - 70px);
      }
    `;
  }}
    ${(0, _breakpoints.default)("tablet", "up")} {
      width: ${function (_ref12) {
    let {
      $fullWidth
    } = _ref12;
    return $fullWidth ? "100%" : "80%";
  }};
    }
    ${(0, _breakpoints.default)("desktop", "up")} {
      ${_index2.default.MediaDisclaimer} {
        ${function (_ref13) {
    let {
      $hasEnvToggle,
      $disclaimerPosition
    } = _ref13;
    return $hasEnvToggle && $disclaimerPosition === "right" && `padding-right: 65px;`;
  }}
      }
    }
    .swiper-wrapper {
      -webkit-transform-style: preserve-3d;
      ${function (_ref14) {
    let {
      $overlay
    } = _ref14;
    return $overlay && `max-height: calc(100vh - 67px);`;
  }}

      /* targeting disclaimer text */
      .swiper-slide-active span {
        ${function (_ref15) {
    let {
      $overlay
    } = _ref15;
    return $overlay && `
          position: sticky;
          margin-top: -17px;
          display: block;
        `;
  }}
      }
    }
    .swiper-slide {
      -webkit-backface-visibility: hidden;
      -webkit-transform: translate3d(0, 0, 0);
    }
  `,
  BtnContainer: _styledComponents.default.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    background: #000;
    opacity: 0.5;
    position: absolute;
    cursor: pointer;
    padding: 0;
    border: none;
    z-index: 2;
    transition: background 0.1s, opacity 0.1s;

    ${(0, _breakpoints.default)("tablet", "up")} {
      ${Stage}:hover & {
        opacity: 0.8;
      }
      transform: ${function (_ref16) {
    let {
      $verticalAlign
    } = _ref16;
    return ($verticalAlign === "middle" || !$verticalAlign) && `translateY(-50%)`;
  }};
      transform: ${function (_ref17) {
    let {
      $left,
      $mirror
    } = _ref17;
    return $left && !$mirror && `rotateZ(0.5turn)`;
  }};
      transform: ${function (_ref18) {
    let {
      $mirror
    } = _ref18;
    return $mirror && `scaleX(-1) translateY(-50%)`;
  }};
    }
    ${function (_ref19) {
    let {
      $verticalAlign
    } = _ref19;
    return $verticalAlign === "top" ? `top: 0` : $verticalAlign === "bottom" ? `bottom: 0` : `top: 50%`;
  }};
    ${function (_ref20) {
    let {
      $left
    } = _ref20;
    return $left ? "left: 0" : "right: 0";
  }}
  `,
  Arrow: (0, _styledComponents.default)(_IconLibrary.ThinArrow)`
    display: inline-block;
    width: 13px;
    height: 26px;
    vertical-align: middle;
    margin-left: 3px;
    fill: #fff;
  `,
  Expand: (0, _styledComponents.default)(_IconLibrary.Expand)`
    display: inline-block;
    width: 25px;
    vertical-align: middle;
    fill: #fff;
  `,
  Swish: (0, _styledComponents.default)(_IconLibrary.Swish)`
    transform: scaleX(-1);
    display: inline-block;
    width: 25px;
    vertical-align: middle;
    fill: #fff;
  `,
  Pagination: _styledComponents.default.div`
    margin-bottom: ${function (_ref21) {
    let {
      $inDrawer
    } = _ref21;
    return $inDrawer ? "0" : "25px";
  }};
    ${function (_ref22) {
    let {
      $inDrawer
    } = _ref22;
    return $inDrawer && "position: absolute;";
  }};
    width: 100%;
    display: flex;
    &:before,
    &:after {
      content: "";
      margin: auto;
    }
  `,
  Dot: _styledComponents.default.button`
    background: #868686;
    border-radius: 50px;
    width: 8px;
    height: 8px;
    border: none;
    padding: 0;
    margin: 0 5px;
    cursor: pointer;
    text-indent: -9999px;
    overflow: hidden;
    white-space: nowrap;
    ${function (_ref23) {
    let {
      active
    } = _ref23;
    return active && `
      background: var(--app-primary-text-color, #000);
    `;
  }}
  `,
  SwatchNav: _styledComponents.default.button`
    padding: 0;
    border: none;
    background: transparent;
    ${function (_ref24) {
    let {
      show
    } = _ref24;
    return !show && `
      pointer-events: none;
      opacity: 0;
      visibility: hidden;
    `;
  }}
  `,
  SwatchArrow: (0, _styledComponents.default)(_IconLibrary.Arrow)`
    display: inline-block;
    width: 14px;
    vertical-align: middle;
    fill: var(--app-primary-text-color, #000);
    ${function (_ref25) {
    let {
      left
    } = _ref25;
    return left ? `
    transform: rotateZ(90deg);
    margin-right: 10px;` : `transform: rotateZ(-90deg);
    margin-left: 10px;`;
  }}
    ${(0, _breakpoints.default)("tablet", "up")} {
      ${function (_ref26) {
    let {
      left
    } = _ref26;
    return left ? `
        margin-right: 25px;` : `
        margin-left: 25px;
        `;
  }}
    }
  `,
  ActiveSwatchText: (0, _Typography.StyledType)("div", {
    family: "nobel-book",
    size: "bodyCopy3"
  })`
    margin: auto;
    max-width: 540px;
    text-align: center;
    padding: 0 20px;
  `,
  ModifierLabel: (0, _Typography.StyledType)("div", {
    family: "nobel-regular",
    size: "legalCopy3"
  })`
    text-align: center;
  `,
  BottomBar: _styledComponents.default.div`
    /* flex-grow: 1;
    text-align: center;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1; */
    background: var(--app-background-color, #fff);
    padding-bottom: 15px;

    ${function (_ref27) {
    let {
      $tabsUnifiedLine
    } = _ref27;
    return $tabsUnifiedLine && `
      ${(0, _breakpoints.default)("mobile")} {
        ${TabList} {
          ul {
            padding: 0 0 10px;
          }
          li:last-child:after {
            display: none;
          }
        }
      }
    `;
  }}
  `,
  PaginationText: (0, _Typography.StyledType)("div", {
    family: "nobel-regular",
    size: "subHeading"
  })`
    text-align: center;
    margin-bottom: 13px;
    & strong {
      font-family: 'nobel-bold'
    }
    ${function (_ref28) {
    let {
      inDrawer
    } = _ref28;
    return inDrawer && `
      position: absolute;
      margin-bottom: 0;
      left: 0;
      right: 0;
    `;
  }};
  `,
  StageWrap: _styledComponents.default.div`
    position: relative;
    width: 100%;
    max-height: 100vh;
    overflow: hidden;
    & .visualizer-drawer {
      z-index: 4;
      &__heading {
        text-align: right;
      }
      background: var(--app-background-color, #fff);
      padding: 0 20px;

      ${_index.DrawerButton} {
        &:after {
          display: none;
        }
      }
    }
  `,
  LoadingWrap: _styledComponents.default.div`
    position: absolute;
    left: 50%;
    top: 50%;
    display: block;
    transform: translate3d(-50%, -50%, 0px);

    ${function (_ref29) {
    let {
      $fixedAspectRatio
    } = _ref29;
    return $fixedAspectRatio && `aspect-ratio: 0.938;`;
  }}
    ${(0, _breakpoints.default)("tablet", "up")} {
      ${function (_ref30) {
    let {
      $fixedAspectRatio
    } = _ref30;
    return $fixedAspectRatio && `aspect-ratio: 1.778;`;
  }}
    }
  `,
  VisualizerContainer: _styledComponents.default.div``,
  Stages: _styledComponents.default.div`
    width: 100%;
    height: 100%;

    & > div:first-child,
    .v360-viewer-container {
      width: 100%;
      height: 100%;
    }
  `
};